import { combineReducers } from "redux";
import { legacy_createStore as createStore } from "redux";
import reducers from "./reducers";
import { compose } from "redux";

const reducer = combineReducers({ ...reducers });

const rootReducer = (defaultState, action) => {
  let state = defaultState;
  if (action.type === "APP:STORE:CLEAR") {
    state = {};
  }

  return reducer(state, action);
};

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true })
    : compose;

const store = composeEnhancers()(createStore)(rootReducer);

export default store;
